module.exports = __webpack_public_path__ + "img/07.1b26bea7.jpg";